import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'widgetProcessName'
})
export class WidgetProcessNamePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return this.processName(value);
  }

  processName(element) {
    if (element.username && element.entity_type) {
      return element.fullname;
    } else if ('triggered' === element.operation && element.details.location_name) { // threshold alarm
      return element.details.location_name;
    } else if ( 'send' === element.operation && element.details.subscription.email) { // operating alarm
      return element.details.subscription.firstname + ' ' + element.details.subscription.lastname;
    } else {
      return 'N/A';
    }
  }
}
